const { serialize } = require("../../utils");

export default {
  namespaced: true,
  state: {
    path: "aljabr/arrival-departure-tickets",
    arrivalTickets: [],
    departureTickets: [],
    loading: false,
    error: null,
  },
  mutations: {
    SET_ARRIVAL_TICKETS(state, tickets) {
      state.arrivalTickets = tickets;
    },
    SET_DEPARTURE_TICKETS(state, tickets) {
      state.departureTickets = tickets;
    },
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
    SET_ERROR(state, error) {
      state.error = error;
    },
    ADD_ARRIVAL_TICKET(state, ticket) {
      state.arrivalTickets.unshift(ticket);
    },
    ADD_DEPARTURE_TICKET(state, ticket) {
      state.departureTickets.unshift(ticket);
    },
    UPDATE_ARRIVAL_TICKET(state, updatedTicket) {
      const index = state.arrivalTickets.findIndex((t) => t._id === updatedTicket._id);
      if (index !== -1) {
        state.arrivalTickets.splice(index, 1, updatedTicket);
      }
    },
    UPDATE_DEPARTURE_TICKET(state, updatedTicket) {
      const index = state.departureTickets.findIndex((t) => t._id === updatedTicket._id);
      if (index !== -1) {
        state.departureTickets.splice(index, 1, updatedTicket);
      }
    },
    DELETE_ARRIVAL_TICKET(state, ticketId) {
      state.arrivalTickets = state.arrivalTickets.filter((t) => t._id !== ticketId);
    },
    DELETE_DEPARTURE_TICKET(state, ticketId) {
      state.departureTickets = state.departureTickets.filter((t) => t._id !== ticketId);
    },
  },
  actions: {
    // Arrival Tickets
    async getArrivalTickets({ dispatch, state, rootState, commit }) {
      if (rootState.authenticated) {
        commit("SET_LOADING", true);
        try {
          const options = { branch: rootState.aljabr.selectedBranch._id };
          const result = await dispatch(
            "FETCH",
            {
              url: `${state.path}/arrival/?${serialize(options)}`,
              method: "GET",
              data: {},
            },
            { root: true }
          );
          commit("SET_ARRIVAL_TICKETS", result.data || []);
          commit("SET_ERROR", null);
          return result;
        } catch (error) {
          commit("SET_ERROR", error);
          throw error;
        } finally {
          commit("SET_LOADING", false);
        }
      }
    },

    async addArrivalTicket({ dispatch, state, rootState, commit }, data) {
      if (rootState.authenticated) {
        commit("SET_LOADING", true);
        try {
          data.branch = rootState.aljabr.selectedBranch._id;
          const result = await dispatch(
            "FETCH",
            {
              url: `${state.path}/arrival/add`,
              method: "POST",
              data,
            },
            { root: true }
          );
          commit("ADD_ARRIVAL_TICKET", result.data);
          commit("SET_ERROR", null);
          return result;
        } catch (error) {
          commit("SET_ERROR", error);
          throw error;
        } finally {
          commit("SET_LOADING", false);
        }
      }
    },

    async updateArrivalTicket({ dispatch, state, rootState, commit }, { id, data }) {
      if (rootState.authenticated) {
        commit("SET_LOADING", true);
        try {
          data.branch = rootState.aljabr.selectedBranch._id;
          const result = await dispatch(
            "FETCH",
            {
              url: `${state.path}/arrival/${id}/update`,
              method: "PUT",
              data,
            },
            { root: true }
          );
          commit("UPDATE_ARRIVAL_TICKET", result.data);
          commit("SET_ERROR", null);
          return result;
        } catch (error) {
          commit("SET_ERROR", error);
          throw error;
        } finally {
          commit("SET_LOADING", false);
        }
      }
    },

    async deleteArrivalTicket({ dispatch, state, rootState, commit }, id) {
      if (rootState.authenticated) {
        commit("SET_LOADING", true);
        try {
          const result = await dispatch(
            "FETCH",
            {
              url: `${state.path}/arrival/${id}/delete`,
              method: "DELETE",
              data: {},
            },
            { root: true }
          );
          commit("DELETE_ARRIVAL_TICKET", id);
          commit("SET_ERROR", null);
          return result;
        } catch (error) {
          commit("SET_ERROR", error);
          throw error;
        } finally {
          commit("SET_LOADING", false);
        }
      }
    },

    async generateArrivalTicketPDF({ dispatch, state, rootState }, ticketId) {
      if (rootState.authenticated) {
        try {
          const result = await dispatch(
            "FETCH",
            {
              url: `${state.path}/arrival/${ticketId}/pdf`,
              method: "GET",
              data: {},
            },
            { root: true }
          );
          return result;
        } catch (error) {
          commit("SET_ERROR", error);
          throw error;
        }
      }
    },

    // Departure Tickets
    async getDepartureTickets({ dispatch, state, rootState, commit }) {
      if (rootState.authenticated) {
        commit("SET_LOADING", true);
        try {
          const options = { branch: rootState.aljabr.selectedBranch._id };
          const result = await dispatch(
            "FETCH",
            {
              url: `${state.path}/departure/?${serialize(options)}`,
              method: "GET",
              data: {},
            },
            { root: true }
          );
          commit("SET_DEPARTURE_TICKETS", result.data || []);
          commit("SET_ERROR", null);
          return result;
        } catch (error) {
          commit("SET_ERROR", error);
          throw error;
        } finally {
          commit("SET_LOADING", false);
        }
      }
    },

    async addDepartureTicket({ dispatch, state, rootState, commit }, data) {
      if (rootState.authenticated) {
        commit("SET_LOADING", true);
        try {
          data.branch = rootState.aljabr.selectedBranch._id;
          const result = await dispatch(
            "FETCH",
            {
              url: `${state.path}/departure/add`,
              method: "POST",
              data,
            },
            { root: true }
          );
          commit("ADD_DEPARTURE_TICKET", result.data);
          commit("SET_ERROR", null);
          return result;
        } catch (error) {
          commit("SET_ERROR", error);
          throw error;
        } finally {
          commit("SET_LOADING", false);
        }
      }
    },

    async updateDepartureTicket({ dispatch, state, rootState, commit }, { id, data }) {
      if (rootState.authenticated) {
        commit("SET_LOADING", true);
        try {
          data.branch = rootState.aljabr.selectedBranch._id;
          const result = await dispatch(
            "FETCH",
            {
              url: `${state.path}/departure/${id}/update`,
              method: "PUT",
              data,
            },
            { root: true }
          );
          commit("UPDATE_DEPARTURE_TICKET", result.data);
          commit("SET_ERROR", null);
          return result;
        } catch (error) {
          commit("SET_ERROR", error);
          throw error;
        } finally {
          commit("SET_LOADING", false);
        }
      }
    },

    async deleteDepartureTicket({ dispatch, state, rootState, commit }, id) {
      if (rootState.authenticated) {
        commit("SET_LOADING", true);
        try {
          const result = await dispatch(
            "FETCH",
            {
              url: `${state.path}/departure/${id}/delete`,
              method: "DELETE",
              data: {},
            },
            { root: true }
          );
          commit("DELETE_DEPARTURE_TICKET", id);
          commit("SET_ERROR", null);
          return result;
        } catch (error) {
          commit("SET_ERROR", error);
          throw error;
        } finally {
          commit("SET_LOADING", false);
        }
      }
    },

    async generateDepartureTicketPDF({ dispatch, state, rootState }, ticketId) {
      if (rootState.authenticated) {
        try {
          const result = await dispatch(
            "FETCH",
            {
              url: `${state.path}/departure/${ticketId}/pdf`,
              method: "GET",
              data: {},
            },
            { root: true }
          );
          return result;
        } catch (error) {
          commit("SET_ERROR", error);
          throw error;
        }
      }
    },
    async uploadFile({ dispatch, state, rootState }, { ticketId, type, data }) {
      if (rootState.authenticated) {
        try {
          const result = await dispatch(
            "FETCH",
            {
              url: `${state.path}/${type}/${ticketId}/upload-file`,
              method: "POST",
              data,
            },
            { root: true }
          );
          return result;
        } catch (error) {
          commit("SET_ERROR", error);
          throw error;
        }
      }
    },
  },
  getters: {
    arrivalTickets: (state) => state.arrivalTickets,
    departureTickets: (state) => state.departureTickets,
    loading: (state) => state.loading,
    error: (state) => state.error,
  },
};
